import { render, staticRenderFns } from "./report-image-upload-modal.vue?vue&type=template&id=2401c968"
import script from "./report-image-upload-modal.vue?vue&type=script&lang=js"
export * from "./report-image-upload-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports